// import jwtDecode from 'jwt-decode';
import { API_BASE_URL } from 'src/config';
import { post, update, get, remove } from 'src/utils/rest';
import ENDPOINTS from 'src/constants/endpoints';
import { resHandler, errorHandler } from 'src/utils/functions';

class FriendService {
follow = id => new Promise((resolve, reject) => {
    get(API_BASE_URL + ENDPOINTS.FOLLOW + id)
        .then(res => {
            resHandler(resolve, reject, res);
        })
        .catch(err => {
            errorHandler(reject, err);
        });
});
unfollow = id => new Promise((resolve, reject) => {
  get(API_BASE_URL + ENDPOINTS.UNFOLLOW + id)
    .then(res => {
        resHandler(resolve, reject, res);
    })
    .catch(err => {
        errorHandler(reject, err);
    });
});
loadFriends = (data) => new Promise((resolve, reject) => {
    post(API_BASE_URL + ENDPOINTS.FRIENDS, data)
        .then(res => {
            resHandler(resolve, reject, res);
        })
        .catch(err => {
            errorHandler(reject, err);
        });
});
loadFollowees = (data) => new Promise((resolve, reject) => {
    post(API_BASE_URL + ENDPOINTS.FOLLOWEES, data)
        .then(res => {
            resHandler(resolve, reject, res);
        })
        .catch(err => {
            errorHandler(reject, err);
        });
})
}

const friendService = new FriendService();

export default friendService;
